import { Evt } from 'evt';

export const updateNetworkStatus = new Evt<{
  isOnline: boolean;
}>();
